import type { Term } from '@/interfaces/service/term.interface';

export const TERM_TITLES = ['PRIVACY_POLICY', 'COLLECTION_USER_PERSONAL_INFO', 'USING_SERVICE'];

export const TERMS: Record<(typeof TERM_TITLES)[number], Term> = {
  PRIVACY_POLICY: {
    koreanTitle: '개인정보처리방침',
    src: 'https://medilawyer-terms.s3.ap-northeast-2.amazonaws.com/privacy-policy.html',
    localUrl: '/terms/privacy-policy.html',
    rel: 'privacy-policy'
  },
  COLLECTION_USER_PERSONAL_INFO: {
    koreanTitle: '개인정보 수집 및 이용',
    src: 'https://medilawyer-terms.s3.ap-northeast-2.amazonaws.com/collection-use-peronal-info.html',
    rel: 'collection-use-peronal-info'
  },
  USING_SERVICE: {
    koreanTitle: '서비스이용약관',
    src: 'https://medilawyer-terms.s3.ap-northeast-2.amazonaws.com/using-service.html',
    localUrl: '/terms/using-service.html',
    rel: 'using-service'
  }
};
